import { render, staticRenderFns } from "./helpicon.vue?vue&type=template&id=921650a8&scoped=true"
import script from "./helpicon.vue?vue&type=script&lang=js"
export * from "./helpicon.vue?vue&type=script&lang=js"
import style0 from "./helpicon.vue?vue&type=style&index=0&id=921650a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921650a8",
  null
  
)

export default component.exports